/* src/app/shared/components/embed-dashboard-card/embed-dashboard-card.component.scss */
.ardoq-card {
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  padding-bottom: 56px;
  cursor: pointer;
}
.ardoq-card:hover {
  opacity: 0.9;
}
@media only screen and (min-width: 720px) {
  .ardoq-card {
    width: 250px;
    height: 345px;
  }
  .ardoq-card-img {
    height: 150px;
    width: 190px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
.ardoq-card-img-container {
  position: relative;
  padding-top: 18px;
}
.report-card-pin-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  font-size: 18px;
}
.ardoq-card-img {
  width: 190px;
  height: 150px;
  object-fit: contain;
}
.ardoq-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
}
.ardoq-icon {
  font-size: 7rem;
  color: var(--ion-color-medium);
}
.ardoq-card-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 9px 2px 0px 2px;
  gap: 6px;
}
.ardoq-card-collection {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 12px;
  padding: 8px;
  white-space: normal;
  word-break: break-word;
  text-align: center;
}
.ardoq-card-title-text {
  font-size: 0.8rem;
  color: var(--ion-color-primary-contrast);
  margin-bottom: 2px;
  text-align: center;
}
.ardoq-card-embed-option {
  position: absolute;
  bottom: 62px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.97rem;
  color: var(--ion-color-medium);
  cursor: default;
}
.ardoq-card-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  box-shadow: none;
  background: var(--ion-card-background, var(--ion-color-tertiary));
  display: flex;
  justify-content: center;
  padding: 4px 0;
}
.embed-card-fav-btn {
  width: 90%;
  max-width: 220px;
  font-weight: 500;
}
@media only screen and (max-width: 720px) {
  .ardoq-card {
    zoom: 0.9;
    width: 196px;
    height: 285px;
  }
  .ardoq-card-img {
    height: 85px;
    width: 120px;
    object-fit: contain;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .ardoq-card-img-container {
    min-height: 85px;
  }
  .ardoq-icon-container {
    height: 85px;
  }
  .ardoq-icon {
    font-size: 4rem;
  }
  .ardoq-card-title-text {
    color: var(--ion-color-primary-contrast);
    font-size: 14px;
  }
  .ardoq-card-collection {
    font-size: 12px;
  }
  .ardoq-card-embed-option {
    background-color: rgba(255, 255, 255, 0.0509803922);
    padding: 3px 10px;
    border-radius: 6px;
  }
}
/*# sourceMappingURL=embed-dashboard-card.component-5V7HIUGQ.css.map */
